import { useSelector } from "react-redux";
import { selectClientPortalMaintenanceDate } from "./MaintenanceSlice";
import { selectCompanyBranding } from "app/modules/system/whiteLabelling/CompanyBrandingSlice";

export const CPLMaintenanceNotification: React.FC = () => {
  const maintenanceDate = useSelector(selectClientPortalMaintenanceDate);
  const clientPortalName = useSelector(selectCompanyBranding)?.clientPortalName ?? "This site";

  return (
    <>
      {maintenanceDate != null && (
        <div className="alert alert-dismissible bg-warning d-flex flex-column flex-sm-row p-5 align-items-center mb-0 mt-10">
          <span className="fa fa-warning fa-xl text-dark me-4"></span>
          <div className="d-flex flex-column pe-0 pe-sm-10 text-dark">
            <h5 className="mb-1 text-dark">Maintenance scheduled</h5>
            <span>
              {`${clientPortalName} will be down for scheduled maintenance from ${maintenanceDate.toCPLUserFriendlyTimeString()} on ${maintenanceDate.toCPLUserFriendlyDateString()}. We apologise for any inconvenience.`}
            </span>
          </div>

          <button
            type="button"
            className="position-absolute position-sm-relative m-2 m-sm-0 top-0 end-0 btn btn-icon ms-sm-auto"
            data-bs-dismiss="alert"
            data-test-id="maintenance-banner__close-button"
          >
            <span className="fa fa-times text-dark"></span>
          </button>
        </div>
      )}
    </>
  );
};
